import { ReduxState } from '../../../../reducers';

export const getMerchantResourcesBooks = (state: ReduxState) =>
  state.merchantsResourcesBooks;
